module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-office-team"
  }, [_c('div', {
    staticClass: "custom-office-team__container custom-office-team__container--tiles"
  }, _vm._l((_vm.props.team_members), function(tile, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-office-team__tile"
    }, [_c('div', {
      staticClass: "custom-office-team__background",
      class: {
        active: _vm.activeTile === i
      },
      on: {
        "mouseover": function($event) {
          _vm.tileActive(i)
        },
        "mouseleave": _vm.tileNotActive
      }
    }, [_c('Icon', {
      staticClass: "custom-office-team__overlay",
      attrs: {
        "name": "team-bg"
      }
    }), _c('div', {
      staticClass: "custom-office-team__content"
    }, [_c('div', {
      staticClass: "custom-office-team__image",
      style: ("backgroundImage: url(" + tile.image + ");")
    }, [_c('div', {
      staticClass: "custom-office-team__image custom-office-team__image--funny",
      style: ({
        backgroundImage: 'url(' + tile.image_funny + ')'
      })
    })]), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTile !== i),
        expression: "activeTile !== i"
      }],
      staticClass: "custom-office-team__name",
      domProps: {
        "innerHTML": _vm._s(tile.name)
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTile !== i),
        expression: "activeTile !== i"
      }],
      staticClass: "custom-office-team__position",
      domProps: {
        "innerHTML": _vm._s(tile.position)
      }
    }), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.activeTile === i),
        expression: "activeTile === i"
      }],
      staticClass: "custom-office-team__bio",
      domProps: {
        "innerHTML": _vm._s(tile.bio)
      }
    })])], 1)])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-89eea09a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-office-team/custom-office-team.pug
// module id = 658
// module chunks = 1